import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/unlisted/$coworld/$league")({
  component: Outlet,
});
